//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Dropdown",
  props: ["data", "multi", "index", "total"],
  data() {
    return {
      value: this.multi ? [] : null,
      menuVisible: false,
      focusIndex: -1
    };
  },
  computed: {
    zIndex() {
      return this.total + 3 - this.index;
    },
    isPlaceholder() {
      return this.multi ? this.value.length === 0 : !this.value;
    },
    displayText() {
      if (this.isPlaceholder) {
        return this.data.placeholder;
      }
      if (this.multi) {
        return `${this.value.length} Selected`;
      }
      return this.value.name;
    }
  },
  methods: {
    toggleDropdown() {
      this.menuVisible = !this.menuVisible;
      this.$refs.menu.scrollTo(0, 0);
    },
    closeDropdown(e) {
      if (!this.$el.contains(e.target)) {
        this.menuVisible = false;
      }
    },
    clearOption() {
      this.menuVisible = false;
      if (this.multi) {
        this.value = [];
      } else {
        this.value = null;
      }
      this.$emit("clear-option", this.data.reference);
    },
    selectOption() {
      if (!this.multi) {
        this.menuVisible = false;
      }
      this.$emit("select-option", [this.data.reference, this.value]);
    },
    handleKeydown(e) {
      if (!this.menuVisible) return;
      e.preventDefault();
      e.stopPropagation();

      switch (e.key) {
        case "Tab":
          if (e.shiftKey) {
            this.focusIndex = (this.focusIndex - 1 + this.data.options.length) % this.data.options.length;
          } else {
            this.focusIndex = (this.focusIndex + 1) % this.data.options.length;
          }
          this.$refs.options[this.focusIndex].focus();
          break;
        case "ArrowDown":
          this.focusIndex = (this.focusIndex + 1) % this.data.options.length;
          this.$refs.options[this.focusIndex].focus();
          break;
        case "ArrowUp":
          this.focusIndex = (this.focusIndex - 1 + this.data.options.length) % this.data.options.length;
          this.$refs.options[this.focusIndex].focus();
          break;
        case "Enter":
        case " ":
          this.$refs.options[this.focusIndex].click();
          break;
        case "Escape":
          this.focusIndex = -1;
          this.menuVisible = false;
          break;
      }
    }
  },
  watch: {
    value() {
      this.selectOption();
    }
  },
  mounted() {
    document.addEventListener("click", this.closeDropdown);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdown);
  }
};
